import * as types from '../constants/ActionTypes';
import { drop, append, without } from 'ramda';
import * as AttachmentUtils from '../helpers/AttachmentUtils';
import { isEmpty } from 'lodash';

const videos = (state = [], action) => {
  switch (action.type) {
    case types.ADD_VIDEO: {
      return append(action.payload.attachmentId, state);
    }
    case types.REMOVE_VIDEO: {
      return drop(1, state);
    }
    case types.ADD_LOCAL_ATTACHMENT: {
      const { attachment } = action.payload;

      if (AttachmentUtils.isVideo(attachment)) {
        return append(attachment.id, state);
      }

      return state;
    }
    case types.REMOVE_MESSAGE: {
      const { attachments } = action.payload.message;

      if (isEmpty(attachments)) {
        return state;
      }

      return without(attachments, state);
    }
    case types.REMOVE_ATTACHMENTS: {
      const { attachmentIds } = action.payload;
      return without(attachmentIds, state);
    }
    default:
      return state;
  }
};

export default videos;
